import crud from '@/crud/form/form'

import computed from './computed'
import data from './data'
import mounted from './mounted'

export default {
  computed,
  data,
  mounted,

  mixins: [crud],

  resourcePath: 'v1/patient/settings/profiles/'
}



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/identification/resources/index.js